import React from 'react';
import PropTypes from 'prop-types';
import popOverBottom from './popover-bottom-view';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Select from 'react-select';
import DropdownIndicator from './select-dropdown-indicator';
import classes from './email-input-group.scss';

export const EmailInputGroup = ({
  name,
  label,
  onChange,
  onBlur,
  domainValue,
  domainOptions,
  onDomainChange,
  domainSelectLabel = '',
  placeholder,
  value,
  error = '',
  helpText,
  infoText,
  isShallowGroup = false,
}) =>
  <div className={`form-group${isShallowGroup ? ' shallow' : ''}${error.length ? ' has-error' : ''}`}>
    <div className={`control-block ${classes.inlineFieldLayout}`}>
      <label htmlFor={`${name}-input`}>{label}
        {helpText &&
          <OverlayTrigger
            container={this}
            trigger="click"
            rootClose
            placement="bottom"
            overlay={popOverBottom(name, helpText)}>
            <i className="togo-icon togo-icon-question-circle togo-icon-question-circle-leftpadding help-icon-move-down" />
          </OverlayTrigger>}
      </label>
      <input
        type="text"
        name={name}
        id={`${name}-input`}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        title={label}
      />
    </div>
    <div className={`control-block ${classes.inlineFieldLayout}`}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor={`${name}_domain`} style={{color: "#FFFFFF"}}>{domainSelectLabel}</label>
      <Select
        name={`${name}_domain`}
        id={`${name}_domain`}
        label=""
        value={domainOptions.find(option => option.value === domainValue) || null}
        onChange={onDomainChange}
        options={domainOptions}
        isSearchable={false}
        clearable={false}
        className="form-control select"
        classNamePrefix="react-select"
        components={{ DropdownIndicator }}
      />
    </div>
    {error && <p className="help-block">{error}</p>}
    {infoText && <p className={`infoText-block ${classes.infoTextOverflow}`}>{infoText}</p>}
  </div>;


EmailInputGroup.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  infoText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  domainValue: PropTypes.string,
  domainSelectLabel: PropTypes.string,
  domainOptions: PropTypes.array.isRequired,
  onDomainChange: PropTypes.func.isRequired,
  isShallowGroup: PropTypes.bool,
};

export default EmailInputGroup;
